import { p as proxyCustomElement, H, h, d as Host } from './p-ae815584.js';

const cosmosIconCss = ":host{color:var(--cosmos-icon-color, inherit);display:inline-block;height:var(--cosmos-icon-size, 1em);vertical-align:-0.1551724138em;width:var(--cosmos-icon-size, 1em)}svg,::slotted(svg){display:block;height:100%;width:100%}";
const CosmosIconPieOutlineStyle0 = cosmosIconCss;

const CosmosIconPieOutline$1 = /*@__PURE__*/ proxyCustomElement(class CosmosIconPieOutline extends H {
    constructor() {
        super();
        this.__registerHost();
        this.__attachShadow();
        this.ariaLabel = undefined;
    }
    getRole() {
        return this.ariaLabel ? 'img' : undefined;
    }
    getAriaHidden() {
        return this.ariaLabel ? false : 'true';
    }
    render() {
        return (h(Host, { key: 'b411518487daf592c67d9b0508365230f62db2a3', role: this.getRole(), "aria-hidden": this.getAriaHidden(), "aria-label": this.ariaLabel }, h("svg", { key: '4dbdf141ccd307ad15e326acf13a04a431b4805d', width: "22", height: "22", viewBox: "0 0 22 22", fill: "none", xmlns: "http://www.w3.org/2000/svg", part: "base" }, h("path", { key: 'b9222ad39bbd3e54c5e26f936fb69cb95ea8b521', "fill-rule": "evenodd", "clip-rule": "evenodd", d: "M12 2c.513 0 1.014.048 1.5.14A8.008 8.008 0 0 1 20 10h-7.5a.5.5 0 0 1-.5-.5V2Zm6.326 6.5A6.51 6.51 0 0 0 13.5 3.674V8.5h4.826ZM10 18.5a6.503 6.503 0 0 0 6.326-5H10.5a2 2 0 0 1-2-2V5.674A6.5 6.5 0 0 0 10 18.5ZM8.5 4.14A8 8 0 1 0 18 12h-7.5a.5.5 0 0 1-.5-.5V4c-.513 0-1.014.048-1.5.14Z", fill: "currentColor" }))));
    }
    static get style() { return CosmosIconPieOutlineStyle0; }
}, [1, "cosmos-icon-pie-outline", {
        "ariaLabel": [513, "aria-label"]
    }]);
function defineCustomElement$1() {
    if (typeof customElements === "undefined") {
        return;
    }
    const components = ["cosmos-icon-pie-outline"];
    components.forEach(tagName => { switch (tagName) {
        case "cosmos-icon-pie-outline":
            if (!customElements.get(tagName)) {
                customElements.define(tagName, CosmosIconPieOutline$1);
            }
            break;
    } });
}

const CosmosIconPieOutline = CosmosIconPieOutline$1;
const defineCustomElement = defineCustomElement$1;

export { CosmosIconPieOutline, defineCustomElement };
